import * as timeZones from '../../data/timeZones.json';
const TimeZonesMgrFactory = () => {
    return {
        getTimeZones() {
            return timeZones;
        },
    };
};
export default TimeZonesMgrFactory;
